export default "__VITE_ASSET__CeA2tHZs__"